import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import compact from 'lodash/compact';
import * as queryString from 'query-string';
import LoadingSpinner from 'components/common/LoadingSpinner';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import Tabs from 'components/common/Tabs';
import Intro from 'components/common/Intro';
import Globe from 'components/common/globe';
import Select from 'components/common/Select';
import CompareOverview from 'components/common/compare-overview';
import ToolsBar from 'components/common/ToolsBar';
import Footer from 'components/common/Footer';
import { roundNumber, isArrayEqual } from 'utils/general';
import { getScoreData } from 'utils/data';
import { isSectorsSame } from 'utils/countryProfile';
import { NUMBER_SELECTABLE_COUNTRY, DEFAULT_SELECT_COUNTRY_OPTION } from 'constants/compare';
import { SECTORS } from 'constants/common';
import CompareCountryReport from 'components/common/compare-country-report';

class ComparePage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      compareCountries: this.props.filters.countries
    };

    this.loading = {};
    this.selectOpts = [];

    // Here you have the available options http://react-component.github.io/collapse/#api.
    this.accordionOptions = {
      accordion: true,
      activeKey: []
    };
  }

  componentWillMount() {
    this.props.getAverages();
    this.props.resetReportData();

    if (this.props.countries.length) {
      this.selectOpts = [
        ...[DEFAULT_SELECT_COUNTRY_OPTION],
        ...this.loadCountryOptions(this.props.countries)
      ];
    } else {
      this.props.getCountries();
    }
    if (compact(this.props.parsedCompareCountries).length) {
      this.setState({
        compareCountries: this.props.parsedCompareCountries
      }, () => {
        this.setCurrentCountries();
      });
    }
  }

  componentWillReceiveProps(newProps) {
    this.setYearSelect(newProps || this.props);
    if (!isEqual(this.props.parsedCompareCountries, newProps.parsedCompareCountries)) {
      this.setState({
        compareCountries: newProps.parsedCompareCountries
      }, () => {
        this.setCurrentCountries();
      });
    } else {
      if (!isEqual(this.props.filters.countries, newProps.filters.countries) && newProps.countries) {
        const compareCountries = newProps.filters.countries.map(iso => {
          if (!newProps.countries.length) return undefined;
          return {
            ...newProps.countries.find(c => c.iso === iso.split('_')[0]),
            iso
          };
        });

        this.setState({
          compareCountries
        }, () => {
          this.setCurrentCountries();
        });
      }
    }

    if (!isArrayEqual(this.props.countries, newProps.countries)) {
      this.selectOpts = [
        ...[DEFAULT_SELECT_COUNTRY_OPTION],
        ...this.loadCountryOptions(newProps.countries)
      ];
    }
  }
  setYearSelect(propsObj) {
    if (!propsObj || !propsObj.filters) return;
    const { pathname } = this.props.router.getCurrentLocation();
    const searchObject = this.getSearchParamObject();
    if (!propsObj.filters.years) return;
    const years = propsObj.filters.years;
    if (!years || !years.length) return;
    const searchYears = searchObject.years || '';
    const searchObjectYears = Array.isArray(searchYears) ? searchYears : searchYears.split(',');
    if (searchObjectYears &&
       searchObjectYears.length === years.length
       && searchObjectYears.filter(el => !years.includes(el)).length === 0) return;
    const queryParams = queryString.stringify({ ...searchObject, years });
    this.props.router.replace(`${pathname}?${queryParams}`);
  }

  setCurrentCountries() {
    const compareCountries = this.state;
    const { years = [] } = this.props.filters;
    Object.values(compareCountries)[0].forEach((v, i) => {
      const country = v;
      const params = country.iso.split('_');
      if (this.reportAlreadyFetched(params[0], params[1], (+i + 1))) return;
      country &&
        this.props.getCountryProfileReport(params[0], params[1], (+i + 1), years);
    });
  }


  getData({ compareCountries, data, getDataByCountry }) {
    Object.keys(compareCountries).forEach((country) => {
      if (compareCountries[country] && !data[country]) {
        this.loading[country] = true;
        const iso = compareCountries[country].iso.split('_')[0];
        getDataByCountry(iso);
      } else {
        this.loading[country] = false;
      }
    });
  }

  setLabelOpacity(country, value) {
    const select = this[country];
    let classOpts = select.props.classOpts;

    if (value === '') {
      classOpts = `${select.props.classOpts} -default`;
    } else {
      const optsArray = select.props.classOpts.split(' ');
      const index = optsArray.indexOf('-default');
      if (index !== -1) {
        optsArray.splice(index, 1);
        classOpts = optsArray.join(' ');
      }
    }

    this[country].classOpts = classOpts;
  }
  getFilterYear() {
    const { years = [] } = this.props.filters;
    return years.length ? years[0] : '';
  }

  getScoreKey() {
    return `score${this.getFilterYear()}`;
  }
  getValues(countriesReports, title, avg, type) {
    const values = Object.keys(countriesReports).map(key => {
      const scoreKey = this.getScoreKey();
      let value = getScoreData(countriesReports[key])[scoreKey];
      if (type === 'category') {
        const category = !isEmpty(countriesReports[key]) && countriesReports[key].categories.find(c => c.category.name === title);
        value = category ? getScoreData(category)[scoreKey] : undefined;
      }
      return {
        country: key,
        value
      };
    });

    return {
      values: values.sort((a, b) => +a.country - +b.country),
      name: title,
      avg
    };
  }

  getCompareCountryTableData() {
    const { countriesReports } = this.props;
    let data = [];
    const scoreKey = this.getScoreKey();

    Object.keys(countriesReports).forEach(el => {
      const countryData = countriesReports[el];
      if (countryData.categories) {
        countryData.categories.forEach(cat => {
          data = this.updateTableData(data, { name: cat.category.name, [countryData.countryNum]: { value: roundNumber(getScoreData(cat)[scoreKey], '-') }, isCategory: true, typeId: 1 });
          if (cat['country-sector-subcategories']) {
            cat['country-sector-subcategories'].forEach(subCat => {
              data = this.updateTableData(data, { name: subCat.subcategory.name, [countryData.countryNum]: { value: roundNumber(getScoreData(subCat)[scoreKey], '-') }, isSubCategory: true, typeId: 2 });
            });
          }
        });
      }
    });
    return data;
  }

  getOverviewValues(reportDataIndex) {
    const { countriesReports, averages } = this.props;
    const overview = [];
    const includeAverage = this.getScoreKey() === 'score2017';
    if (reportDataIndex) {
      overview.push(
        this.getValues(countriesReports, 'Composite',
        includeAverage ? roundNumber(((averages.composite || {}).attributes || {}).average) : null, 'composite')
      );

      countriesReports[reportDataIndex].categories.forEach(cat => {
        const average = averages.categories.find(c => c.attributes.name === cat.category.name);
        overview.push(this.getValues(countriesReports, cat.category.name, includeAverage ? roundNumber(average && average.attributes ? average.attributes.average : null) : null, 'category'));
      });
    }
    return overview;
  }

  getOverviewLegend() {
    const { countriesReports } = this.props;
    const legend = [];

    Object.keys(countriesReports).forEach(key => {
      countriesReports[key] && countriesReports[key].name &&
      legend.push({ country: key, value: countriesReports[key].name });
    });
    if (this.getScoreKey() === 'score2017') { legend.push({ country: 4, value: 'Sample average score' }); }

    return legend;
  }
  getSearchParamObject() {
    const { search } = this.props.router.getCurrentLocation();
    return queryString.parse(search);
  }
  getSelectedYearScore(sectorData) {
    const scoreKey = this.getScoreKey();
    const scoreData = getScoreData(sectorData);
    return scoreData[scoreKey];
  }
  reportAlreadyFetched(iso, countrySector, countryNum) {
    const year = this.getFilterYear();
    const countryReports = this.props.countriesReports || {};
    const numCountry = countryReports[countryNum] || {};
    return numCountry.iso === iso && numCountry.countrySectorName === countrySector && String(numCountry.year) === String(year);
  }
  handleCountrySelect(countrySelector, value, index) {
    const { search, pathname } = this.props.router.getCurrentLocation();
    const iso = value.split('_')[0];
    const sector = value.split('_')[1];

    const searchObject = queryString.parse(search);
    const objectParams = {};

    // itertates adding the country selector and its value to the object
    Object.keys(searchObject).forEach(key => {
      objectParams[key] = searchObject[key];
    });

    // adds latest country selector and value selected by the user
    objectParams[countrySelector] = value === '' ? undefined : value;

    objectParams.years = this.props.filters.years;

    // updates URL
    const queryParams = queryString.stringify(objectParams);
    this.props.router.replace(`${pathname}?${queryParams}`);

    // if a user selects the same country in the same selector
    // that was setted previously, nothing happens
    if (this.state.compareCountries.length &&
      this.state.compareCountries[index] &&
      this.state.compareCountries[index].iso === value) return;

    this.updateCountryInfo(index, { iso, sector });
    this.setLabelOpacity(countrySelector, iso);
  }

  handleParamChange(params, value) {
    const { pathname } = this.props.router.getCurrentLocation();
    // const searchObject = this.getSearchParamObject();
    const objectParams = { };
    if (params === 'years') {
      objectParams.years = value;
    }
    const queryParams = queryString.stringify(objectParams);
    this.props.resetReportData();
    this.props.router.replace(`${pathname}?${queryParams}`);
  }

  updateCountryInfo(index, country) {
    const { compareCountries } = this.state;
    const { iso, sector } = country;

    compareCountries.splice(index, 1);
    const newCountry = {
      ...this.props.countries.find(c => c.iso === iso),
      iso: `${iso}_${sector}`
    };
    compareCountries.splice(index, 0, newCountry);
    const { years = [] } = this.props.filters;
    this.props.getCountryProfileReport(country.iso, country.sector, index + 1, years);

    this.setState({
      compareCountries
    });
  }
  updateTableData(array = [], data) {
    const newArray = [...array];
    const index = newArray.findIndex(el => el.name === data.name && el.typeId === data.typeId);

    if (index >= 0) {
      const newItem = { ...array[index], ...data };
      newArray[index] = {
        ...newItem
      };
    } else newArray.push(data);
    return newArray;
  }
  loadCountryOptions(countries) {
    const countryOptions = [];
    countries.forEach(country => {
      const countrySectors = country['country-sectors'];
      if (countrySectors.length > 1) {
        countryOptions.push(
          { label: `${country.name} - Mining`, value: `${country.iso}_mining` },
          { label: `${country.name} - Oil & Gas`, value: `${country.iso}_oil-gas` }
        );
      } else {
        const sector = countrySectors.length ?
        countrySectors[0].sector : {};

        const sectorName = (SECTORS.find(sec => sec.id === +sector.id || isSectorsSame(sec.label, sector.name)) || {}).label;

        countryOptions.push({ label: `${country.name} - ${sectorName}`, value: `${country.iso}_${sector.name}` });
      }
    });
    return countryOptions;
  }


  render() {
    const { countriesReports, countries, data } = this.props;
    const selects = [];
    const searchable = window.innerWidth > 769;
    const { years: selectedYears = [] } = this.props.filters || {};
    const selectedYear = selectedYears.length ? String(selectedYears[0]) : '';
    const allYearsOptions = [2017, 2021].map((el) => ({
      label: String(el),
      value: String(el),
      noIcon: true
    }));
    for (let i = 0; i < NUMBER_SELECTABLE_COUNTRY; i++) {
      const country = this[`country${i + 1}`];
      const countryProps = countries[i] !== '' ?
        `-globe country${i + 1}` :
        `-globe country${i + 1} -default`;
      const classOpts = country && country.classOpts ? country.classOpts : countryProps;
      const countryData = this.state.compareCountries[i];
      const sectorData = countryData &&
        countryData['country-sectors'] &&
        countryData['country-sectors'].find(sec => sec.sector.name === countryData.iso.split('_')[1]);
      selects.push(
        <Select
          ref={(node) => { this[`country${i + 1}`] = node; }}
          color={`color${i + 1}`}
          classOpts={classOpts}
          searchable={searchable}
          clearable={false}
          autosize={false}
          value={countryData && countryData.iso ?
            countryData.iso : DEFAULT_SELECT_COUNTRY_OPTION.value}
          options={this.selectOpts}
          onChange={(option) => this.handleCountrySelect(`country${i + 1}`, option.value, i)}
        >
          <div className="scores">
            <h2>{sectorData ? roundNumber(this.getSelectedYearScore(sectorData)) : '–'}</h2>
          </div>
          <Globe
            selectedCountry={countryData && countryData.iso ?
              countryData.iso.split('_')[0] : DEFAULT_SELECT_COUNTRY_OPTION.value}
            interctivity={false}
            theme={`-light -thin color${i + 1}`}
          />
        </Select>
      );
    }

    const reportDataIndex = Object.keys(countriesReports).find(key => (
      Object.keys(countriesReports[key]).length
    ));
    const overviewValues = this.getOverviewValues(reportDataIndex);

    return (
      <div className="l-main -compare">
        <Intro section="compare">
          <ToolsBar setModalContent={this.props.setModalContent} hasDownload={false} />
          <div className="row">
            <div className="column small-12 medium-8 large-6">
              <h1 className="title -section-title -light">Compare Countries</h1>
              <p className="-light">
                Compare up to three countries composite, component and subcomponent scores (includes option to compare both oil & gas and mining sectors for dual sector countries).
              </p>
            </div>
            <div className="column small-12 medium-4 large-offset-2">
              <Tabs
                value={selectedYear}
                options={allYearsOptions}
                onChange={(option) => this.handleParamChange('years', option.value)}
                wrapperClass={'-v-offset'}
              />
            </div>
          </div>
          <div className="row">
            {selects.map((select, index) => (
              <div key={index} className="select-compare column small-12 medium-4 medium-small-10 large-4">
                {select}
              </div>
            ))}
          </div>
          {compact(this.props.filters.countries).length > 0 &&
            <CompareOverview
              title="Overview"
              loading={this.props.countriesReportsLoading}
              data={{
                overview: overviewValues,
                legend: this.getOverviewLegend()
              }}
            />
          }
        </Intro>
        {this.props.loading && <LoadingSpinner />}
        {Object.keys(data).length > 0 &&
          <section className="page-report -compare">
            <div className="row header">
              <div className="column small-12 medium-6">
                <h1></h1>
              </div>
            </div>
            <div className="l-content -data-report -compare">
              <CompareCountryReport title="Composite Scores Table" data={this.getCompareCountryTableData()} countriesReports={this.props.countriesReports} />
            </div>
          </section>
          }
        <Footer />
      </div>
    );
  }
}


ComparePage.propTypes = {
  getDataByCountry: PropTypes.func.isRequired,
  getCountries: PropTypes.func.isRequired,
  getActiveYears: PropTypes.func.isRequired,
  resetReportData: PropTypes.func.isRequired,
  getAverages: PropTypes.func.isRequired,
  setModalContent: PropTypes.func,
  countriesReports: PropTypes.object,
  getCountryProfileReport: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
  averages: PropTypes.object,
  data: PropTypes.object.isRequired,
  countries: PropTypes.array.isRequired,
  parsedCompareCountries: PropTypes.array,
  totalAssestments: PropTypes.number,
  activeYears: PropTypes.array,
  filters: PropTypes.object.isRequired,
  loading: PropTypes.bool,
  countriesReportsLoading: PropTypes.bool
};

ComparePage.defaultProps = {
  filters: {
    countries: [],
    years: []
  },
  parsedCompareCountries: []
};

export default withRouter(ComparePage);



// WEBPACK FOOTER //
// ./app/components/compare/index.jsx